module.exports = __webpack_public_path__ + "img/plan-m.6d5014b8.png";